const billingToastOptions = {
	position: 'top-right',
	autoClose: 180000,
	closeOnClick: true,
	pauseOnHover: true,
};

/**
 * Normalize API / Stripe errors into a user-facing string.
 */
export const billingErrorMessage = (error, fallback = 'Billing request failed. Please try again or contact support.') => {
	if (!error) {
		return fallback;
	}

	if (typeof error === 'string' && error.trim()) {
		return error.trim();
	}

	const fromResponse = error?.responseJSON?.response
		?? error?.response?.response
		?? error?.responseJSON?.message
		?? error?.response?.message;

	if (typeof fromResponse === 'string' && fromResponse.trim()) {
		return fromResponse.trim();
	}

	if (typeof error?.message === 'string' && error.message.trim()) {
		// RestfulObject wraps API body as `Error: <body>` / `Error: Error: <body>`
		return error.message.replace(/^(Error:\s*)+/i, '').trim() || fallback;
	}

	return fallback;
};

export const showBillingError = (API, error, fallback) => {
	const message = billingErrorMessage(error, fallback);
	API.Toast.error(message, {
		...billingToastOptions,
		position: API.Toast.POSITION.TOP_RIGHT,
	});
	return message;
};

export const showBillingSuccess = (API, message) => {
	API.Toast.success(message, {
		position: API.Toast.POSITION.TOP_RIGHT,
		autoClose: 4000,
		closeOnClick: true,
		pauseOnHover: true,
	});
};
